import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-tenant',
  templateUrl: './manage-tenant.component.html',
  styleUrls: ['./manage-tenant.component.css']
})
export class ManageTenantComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
